export default function MegaMarquee({
  words = ["TOXIC STREET", "DISCIPLINE OVER EVERYTHING", "STAY DANGEROUS", "TRUST NO ONE"],
  reverse = false,
}) {
  const items = Array.from({ length: 6 });
  return (
    <div
      data-testid="mega-marquee"
      className="border-y border-white/20 bg-ink overflow-hidden py-3 sm:py-5 no-scrollbar"
    >
      <div
        className="flex w-[200%] whitespace-nowrap"
        style={{
          animation: `marquee ${reverse ? "45s" : "35s"} linear infinite`,
          animationDirection: reverse ? "reverse" : "normal",
        }}
      >
        {items.map((_, i) => (
          <span key={i} className="flex items-center px-6">
            {words.map((w, j) => (
              <span key={j} className="flex items-center">
                <span className="font-anton uppercase tracking-tighter text-5xl sm:text-7xl text-bone">{w}</span>
                <span className="font-anton uppercase tracking-tighter text-5xl sm:text-7xl text-transparent mx-4" style={{ WebkitTextStroke: "1.5px #CC0000" }}>★</span>
                <span className="font-anton uppercase tracking-tighter text-5xl sm:text-7xl text-transparent mx-4" style={{ WebkitTextStroke: "1.5px #F3F3F1" }}>{w}</span>
                <span className="font-anton uppercase tracking-tighter text-5xl sm:text-7xl text-blood mx-4">★</span>
              </span>
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}
